module.exports = __webpack_public_path__ + "img/wide.157a9301.jpg";